import { render, staticRenderFns } from "./sort_print.vue?vue&type=template&id=22bbdcb8&scoped=true"
import script from "./sort_print.vue?vue&type=script&lang=js"
export * from "./sort_print.vue?vue&type=script&lang=js"
import style0 from "./sort_print.vue?vue&type=style&index=0&id=22bbdcb8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bbdcb8",
  null
  
)

export default component.exports